<template>
  <div class="navItemDetails">
    <!-- Sub items -->
    <template v-if="selected">
      <div>
        <nav-records-user
          v-for="(tenant, index) in tenants"
          :key="tenant.id"
          :target-id="tenant.id"
          :type="'tenant'"
          :name="tenant.first_name + ' ' + tenant.last_name.toUpperCase()"
          :subtitle="$t('records.nav.tenant') + ' ' + $t('records.nav.number') + (index + 1)"
          :bubble="$t('records.nav.tenant').substring(0, 1) + (index + 1)"
          notification="0"
          :bordered="currentRecord && currentRecord.offer && tenants.length === currentRecord.offer.unit_type.roomates_count"
          :valid="!!tenant.confirmed_at"
          :invalid="tenant.confirmation_sent_at && !tenant.confirmed_at"
          deleteable
        />
      </div>
      <el-button
        v-if="currentRecord && currentRecord.offer && tenants.length < currentRecord.offer.unit_type.roomates_count"
        type="info"
        @click="$router.push({ name: 'records-tenant' })"
      >
        <md-icon name="add_circle" />
        <p>{{ $t('records.nav.addTenants') }}</p>
      </el-button>
    </template>
  </div>
</template>

<script>
import NavRecordsInterface from './NavRecordsInterface'
import NavRecordsUser from './NavRecordsUser'
import { mapState } from 'vuex'

export default {
  name: "NavRecordsTenantDetails",
  components: {
    NavRecordsUser
  },
  extends: NavRecordsInterface,
  computed: {
    ...mapState({
      currentRecord: state => state.records.currentRecord,
      tenants: state => state.recordsPeople.currentRecordTenants
    })
  }
}
</script>

<style lang="scss" scoped>
.el-button {
  i,
  p {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    padding-left: 5px;
  }
}
</style>